import classNames from 'classnames';

import Back from '@/assets/icons/back.svg?react';
import DynamicT from '@/ds-components/DynamicT';
import FlipOnRtl from '@/ds-components/FlipOnRtl';
import TextLink from '@/ds-components/TextLink';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

function BackToDashboardLink({ className }: Props) {
  return (
    <TextLink
      to="/dashboard"
      className={classNames(styles.link, className)}
      icon={
        <FlipOnRtl>
          <Back />
        </FlipOnRtl>
      }
    >
      <DynamicT forKey="tenants.back_to_dashboard" />
    </TextLink>
  );
}

export default BackToDashboardLink;
